export default {
  preview: {
    label: 'Previzualizare',
    tooltip: 'Previzualizează pagina de comandă online într-un tab nou.',
  },
  buttons: {
    visit_online_store: 'Magazin online',
  },
  toasts: {
    failed_to_launch_orders_portal_app: 'Lansarea portalului de comenzi a eșuat',
  },
};
